import { ApiError } from '@fusapp-work/api'
import { z } from 'zod'
/** Parse before caching; unexpected transport data is not a form validation error. */
export function parseResponse<T extends z.ZodType>(schema: T, value: unknown): z.output<T> {
  const result = schema.safeParse(value)
  if (!result.success) throw new ApiError('Invalid domain response', 200, 'INVALID_RESPONSE')
  return result.data
}
